import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '../Dialog';
import translations from './translations';

const PrintingFailedDialog = ({
  isOpen,
  title,
  message,
  onClose,
  onRetry,
  onDownload,
  showCloseButton,
}) => (
  <Dialog open={isOpen} maxWidth="xs" onClose={onClose}>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <DialogContentText>{message}</DialogContentText>
    </DialogContent>
    <DialogActions>
      {showCloseButton && (
        <Button onClick={onClose} variant="outlined" style={{ marginRight: 'auto' }}>
          <FormattedMessage {...translations.printingFailedDialog.actions.close} />
        </Button>
      )}
      <Button
        onClick={onDownload}
        color="primary"
        variant="outlined"
        style={!showCloseButton ? { marginRight: 'auto' } : {}}
      >
        <FormattedMessage {...translations.printingFailedDialog.actions.download} />
      </Button>
      <Button onClick={onRetry} color="primary" variant="contained">
        <FormattedMessage {...translations.printingFailedDialog.actions.retry} />
      </Button>
    </DialogActions>
  </Dialog>
);

PrintingFailedDialog.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onDownload: PropTypes.func,
  onRetry: PropTypes.func,
  showCloseButton: PropTypes.bool,
};

PrintingFailedDialog.defaultProps = {
  isOpen: false,
  onClose: undefined,
  onDownload: undefined,
  onRetry: undefined,
  showCloseButton: false,
};

export default PrintingFailedDialog;
